import React, { useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import CallToActionButton from '../../../../../../component/call-to-action-button/call-to-action-button';
import { createCalendarVacationOperation } from '../operations/create-calendar-vacation-operation';

interface AddCalendarVacationDialogProps {
  closeDialog: () => void;
}

export const AddCalendarVacationDialog: React.FC<
  AddCalendarVacationDialogProps
> = ({ closeDialog }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState(false);

  const handleApprove = async () => {
    await createCalendarVacationOperation(
      {
        title,
        description,
        startDate,
        endDate,
      },
      setLoading,
      closeDialog,
    );
  };

  return (
    <div>
      <EditText
        title={'כותרת'}
        value={title}
        onChange={setTitle}
        maxLength={50}
      />

      <div style={{ marginBottom: '16px' }}>
        <label style={{ fontSize: '14px', color: '#4b5563' }}>תיאור</label>
        <InputTextarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={4}
          maxLength={255}
          style={{ width: '100%', marginTop: '4px', resize: 'vertical' }}
          placeholder="תיאור (אופציונלי)"
        />
        <div style={{ marginTop: '4px', fontSize: '12px', color: '#6A6A6A' }}>
          {description.length} / 255 תווים
        </div>
      </div>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <div style={{ minWidth: '250px', flex: 1 }}>
          <label style={{ fontSize: '14px', color: '#4b5563' }}>מתאריך</label>
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate((e.value as Date) ?? null)}
            showIcon
            dateFormat="dd/mm/yy"
            style={{ width: '100%', marginTop: '4px', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
          />
        </div>

        <div style={{ minWidth: '250px', flex: 1 }}>
          <label style={{ fontSize: '14px', color: '#4b5563' }}>עד תאריך</label>
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate((e.value as Date) ?? null)}
            showIcon
            dateFormat="dd/mm/yy"
            style={{ width: '100%', marginTop: '4px', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
          />
        </div>
      </div>

      <div style={{ height: '12px' }} />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CallToActionButton
          text={'אישור'}
          onClick={handleApprove}
          loading={loading}
        />
      </div>
    </div>
  );
};
